module.exports = __webpack_public_path__ + "img/csv.a4f018b9.svg";